module.exports = __webpack_public_path__ + "static/media/ico_user.0962f88d.png";